import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { PureComponent } from 'react';
import Lozenge from '@atlaskit/lozenge';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { createStatusAnalyticsAndFire } from './analytics';
import { ANALYTICS_HOVER_DELAY } from './constants';
var colorToLozengeAppearanceMap = {
  neutral: 'default',
  purple: 'new',
  blue: 'inprogress',
  red: 'removed',
  yellow: 'moved',
  green: 'success'
};
var DEFAULT_APPEARANCE = 'default';
var MAX_WIDTH = 200;

var StatusInternal = /*#__PURE__*/function (_PureComponent) {
  _inherits(StatusInternal, _PureComponent);

  var _super = _createSuper(StatusInternal);

  function StatusInternal() {
    var _this;

    _classCallCheck(this, StatusInternal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "hoverStartTime", 0);

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function (_e) {
      _this.hoverStartTime = Date.now();
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function (_e) {
      var onHover = _this.props.onHover;

      var delay = Date.now() - _this.hoverStartTime;

      if (delay >= ANALYTICS_HOVER_DELAY && onHover) {
        onHover();
      }

      _this.hoverStartTime = 0;
    });

    return _this;
  }

  _createClass(StatusInternal, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.hoverStartTime = 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          text = _this$props.text,
          color = _this$props.color,
          style = _this$props.style,
          localId = _this$props.localId,
          onClick = _this$props.onClick;

      if (text.trim().length === 0) {
        return null;
      }

      var appearance = colorToLozengeAppearanceMap[color] || DEFAULT_APPEARANCE; // Note: ommitted data-local-id attribute to avoid copying/pasting the same localId

      return /*#__PURE__*/React.createElement("span", {
        className: "status-lozenge-span",
        onClick: onClick,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        "data-node-type": "status",
        "data-color": color,
        "data-style": style,
        id: localId
      }, /*#__PURE__*/React.createElement(Lozenge, {
        appearance: appearance,
        maxWidth: MAX_WIDTH
      }, text));
    }
  }]);

  return StatusInternal;
}(PureComponent);

_defineProperty(StatusInternal, "displayName", 'StatusInternal');

export var Status = withAnalyticsEvents({
  onClick: function onClick(createEvent, props) {
    var localId = props.localId;
    return createStatusAnalyticsAndFire(createEvent)({
      action: 'clicked',
      actionSubject: 'statusLozenge',
      attributes: {
        localId: localId
      }
    });
  },
  onHover: function onHover(createEvent, props) {
    var localId = props.localId;
    return createStatusAnalyticsAndFire(createEvent)({
      action: 'hovered',
      actionSubject: 'statusLozenge',
      attributes: {
        localId: localId
      }
    });
  }
})(StatusInternal);